module.exports = __webpack_public_path__ + "img/DNARepair-CECA_10X_CC.2d55eca1.png";